<template>
  <b-modal
    id="article-modal"
    :title="
      readonly
        ? 'عرض المعلومات'
        : form.id
        ? 'تحديث بيانات المقال'
        : 'أضافة مقال جديد'
    "
    shadow
    hide-footer
    :no-close-on-backdrop="true"
    @hidden="clearForm"
    size="lg"
    body-class="p-5"
  >
    <div class="px-3 py-2">
      <VForm v-slot="{ onValidate }">
        <VFileField
          v-model="form.image"
          label="صورة الغلاف"
          type=".jpg, .png"
          :disabled="readonly"
        ></VFileField>
        <VTextField
          v-model="form.title"
          label="عنوان المقالة"
          rules="required"
          :readonly="readonly"
        ></VTextField>
        <VTextEditor v-model="form.content" :readonly="readonly"></VTextEditor>
        <b-row v-if="!readonly">
          <b-col>
            <b-button
              :variant="form.id ? 'success' : 'info'"
              block
              @click="onValidate(action)"
              >{{ form.id ? "تحديث" : "أضافة" }}</b-button
            >
          </b-col>
          <b-col>
            <b-button
              variant="outline-info"
              block
              @click="$bvModal.hide('article-modal')"
              >الغاء</b-button
            >
          </b-col>
        </b-row>
      </VForm>
    </div>
  </b-modal>
</template>
<script>
import { clearObject, successAlert, errorAlert } from "@/utils/helper";
export default {
  props: { readonly: Boolean, state: String },
  computed: {
    form: {
      get() {
        return this.$store.state.admin.articles.form;
      },
      set(value) {
        this.$store.commit("admin/articles/SET_ARTICLE", value);
      },
    },
  },
  methods: {
    action() {
      var state = this.form.id ? "update" : "store";
      this.$store
        .dispatch(`admin/articles/${state}`)
        .then((response) => {
          successAlert();
          this.$bvModal.hide("article-modal");
          this.$store.commit(
            `admin/articles/${state.toUpperCase()}_ARTICLE`,
            response.payload
          );
        })
        .catch((error) =>
          errorAlert(
            error.response ? error.response.data.message : "حدثت مشكله"
          )
        );
    },
    clearForm() {
      this.form = clearObject(this.form);
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss"></style>
